/* ============================================================
   PCHEEBUM — Shopify Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  // ── Header: static, always cream (no scroll behavior) ───
  function initHeader() {
    // Header is position:relative and always shows cream background.
    // Nothing to initialize — no scroll listener needed.
  }

  // ── Hero Carousel ─────────────────────────────────────────
  function initHeroCarousel() {
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero-slide');
    const dots = carousel.querySelectorAll('.hero-dot');
    const prevBtn = carousel.querySelector('.hero-arrow--prev');
    const nextBtn = carousel.querySelector('.hero-arrow--next');
    const progressBar = carousel.querySelector('.hero-carousel__progress-bar');

    if (!slides.length) return;

    let current = 0;
    let autoplayTimer = null;
    let progressTimer = null;
    let progressStart = null;
    const AUTOPLAY_MS = 6000;
    const TYPEWRITER_SPEED = 45;

    function getSlide(i) { return slides[i]; }

    // Typewriter effect
    function typewriter(el, html, onDone) {
      const steps = [];
      let i = 0;
      while (i < html.length) {
        if (html[i] === '<') {
          const end = html.indexOf('>', i);
          i = (end !== -1) ? end + 1 : i + 1;
        } else {
          i++;
        }
        steps.push(html.substring(0, i));
      }

      let step = 0;
      el.innerHTML = '';

      const cursor = document.createElement('span');
      cursor.className = 'typing-cursor';
      cursor.textContent = '|';

      function tick() {
        if (step < steps.length) {
          el.innerHTML = steps[step];
          el.appendChild(cursor);
          step++;
          setTimeout(tick, TYPEWRITER_SPEED);
        } else {
          setTimeout(() => {
            cursor.style.transition = 'opacity 0.3s ease';
            cursor.style.opacity = '0';
            setTimeout(() => { cursor.remove(); if (onDone) onDone(); }, 300);
          }, 900);
          if (onDone) setTimeout(onDone, 200);
        }
      }
      tick();
    }

    function showSlideContent(slide) {
      const eyebrow = slide.querySelector('.hero-slide__eyebrow');
      const headlineEl = slide.querySelector('.hero-slide__headline');
      const sub = slide.querySelector('.hero-slide__sub');
      const ctas = slide.querySelector('.hero-slide__ctas');
      const headlineHTML = headlineEl ? headlineEl.getAttribute('data-headline') : '';

      if (eyebrow) {
        setTimeout(() => eyebrow.classList.add('is-visible'), 100);
      }

      if (headlineEl && headlineHTML) {
        headlineEl.innerHTML = '';
        setTimeout(() => {
          typewriter(headlineEl, headlineHTML, () => {
            if (sub) sub.classList.add('is-visible');
          });
        }, 300);
        // Show the CTA in parallel with the typewriter (≈300ms in) instead of
        // waiting for the full typewriter completion (~2.5s). Customers should
        // be able to tap "SHOP BEST SELLERS" immediately on landing.
        if (ctas) setTimeout(() => ctas.classList.add('is-visible'), 350);
      } else {
        if (sub) setTimeout(() => sub.classList.add('is-visible'), 500);
        if (ctas) setTimeout(() => ctas.classList.add('is-visible'), 350);
      }
    }

    function hideSlideContent(slide) {
      const els = slide.querySelectorAll('.hero-slide__eyebrow, .hero-slide__sub, .hero-slide__ctas');
      els.forEach(el => el.classList.remove('is-visible'));
    }

    function goTo(next) {
      if (next === current) return;
      const prevSlide = getSlide(current);
      const nextSlide = getSlide(next);

      hideSlideContent(prevSlide);
      prevSlide.classList.remove('is-active');
      prevSlide.classList.add('is-prev');

      current = next;
      nextSlide.classList.add('is-active');
      nextSlide.classList.remove('is-prev');

      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));

      setTimeout(() => {
        prevSlide.classList.remove('is-prev');
        showSlideContent(nextSlide);
      }, 400);

      resetAutoplay();
    }

    function startProgress() {
      if (progressBar) {
        progressStart = Date.now();
        progressBar.style.width = '0%';
        progressTimer = setInterval(() => {
          const elapsed = Date.now() - progressStart;
          const pct = Math.min((elapsed / AUTOPLAY_MS) * 100, 100);
          progressBar.style.width = pct + '%';
        }, 50);
      }
    }

    function stopProgress() {
      if (progressTimer) { clearInterval(progressTimer); progressTimer = null; }
      if (progressBar) progressBar.style.width = '0%';
    }

    function resetAutoplay() {
      stopProgress();
      if (autoplayTimer) clearTimeout(autoplayTimer);
      startProgress();
      autoplayTimer = setTimeout(() => {
        goTo((current + 1) % slides.length);
      }, AUTOPLAY_MS);
    }

    // Init first slide
    getSlide(0).classList.add('is-active');
    dots[0]?.classList.add('is-active');
    showSlideContent(getSlide(0));
    resetAutoplay();

    // Dot clicks
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Arrow clicks
    if (prevBtn) prevBtn.addEventListener('click', () => goTo((current - 1 + slides.length) % slides.length));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo((current + 1) % slides.length));

    // Pause on hover
    carousel.addEventListener('mouseenter', () => { if (autoplayTimer) clearTimeout(autoplayTimer); stopProgress(); });
    carousel.addEventListener('mouseleave', resetAutoplay);

    // Touch swipe
    let touchStartX = 0;
    carousel.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        goTo(diff > 0
          ? (current + 1) % slides.length
          : (current - 1 + slides.length) % slides.length
        );
      }
    }, { passive: true });
  }

  // ── Mobile Menu ───────────────────────────────────────────
  function initMobileMenu() {
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const closeBtn = document.getElementById('mobile-menu-close');
    if (!hamburger || !mobileMenu) return;

    function toggle(open) {
      mobileMenu.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      hamburger.setAttribute('aria-expanded', open);
    }

    hamburger.addEventListener('click', () => toggle(!mobileMenu.classList.contains('is-open')));
    closeBtn?.addEventListener('click', () => toggle(false));
    // Close on Escape key — accessibility / standard modal behavior
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) toggle(false);
    });
  }

  // ── Cart Drawer ───────────────────────────────────────────
  function initCartDrawer() {
    // Always query fresh — never cache overlay/drawer references
    function getOverlay() { return document.querySelector('.cart-overlay'); }
    function getDrawer()  { return document.querySelector('.cart-drawer'); }
    function getDrawerSection() {
      return document.getElementById('shopify-section-cart-drawer')
        || getDrawer()?.parentElement;
    }

    function bindDrawerEvents() {
      // Use replaceWith trick to remove old listeners before adding new ones
      var closeBtn = getDrawer()?.querySelector('.cart-drawer__close');
      if (closeBtn) {
        var newBtn = closeBtn.cloneNode(true);
        closeBtn.parentNode?.replaceChild(newBtn, closeBtn);
        newBtn.addEventListener('click', closeCart);
      }
      // Overlay: remove old listener by replacing the element reference approach
      // Use a named handler stored on the element to avoid stacking
      var overlay = getOverlay();
      if (overlay && !overlay._closeHandlerBound) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) closeCart();
        });
        overlay._closeHandlerBound = true;
      }
    }

    function openCart() {
      getOverlay()?.classList.add('is-open');
      getDrawer()?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      getOverlay()?.classList.remove('is-open');
      getDrawer()?.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Re-render drawer — keep it visually open if it already was
    async function refreshCartDrawer() {
      const wasOpen = getDrawer()?.classList.contains('is-open');
      try {
        const res = await fetch('/?sections=cart-drawer');
        if (!res.ok) return;
        const data = await res.json();
        const html = data['cart-drawer'];
        if (!html) return;
        const wrap = getDrawerSection();
        if (wrap) {
          wrap.innerHTML = html;
          // Immediately restore open state so drawer doesn't disappear
          if (wasOpen) {
            getDrawer()?.classList.add('is-open');
            getOverlay()?.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          }
          bindDrawerEvents();
          if (typeof window.initCartDrawerV2 === 'function') window.initCartDrawerV2();
        }
      } catch(e) { /* fallback: open stale content */ }
    }

    document.querySelectorAll('[data-open-cart]').forEach(btn =>
      btn.addEventListener('click', openCart)
    );
    bindDrawerEvents();

    // Close drawer on Escape key — accessibility / standard modal behavior.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && getDrawer()?.classList.contains('is-open')) closeCart();
    });

    window.pcheebumCart = {
      open: openCart,
      close: closeCart,
      refresh: refreshCartDrawer,
      refreshAndOpen: async function() {
        await refreshCartDrawer();
        openCart();
      }
    };
  }

  // ── Scroll Reveal ─────────────────────────────────────────
  function initScrollReveal() {
    const els = document.querySelectorAll('.reveal');
    if (!els.length || !window.IntersectionObserver) {
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => obs.observe(el));
  }

  // ── Product Gallery (PDP) ─────────────────────────────────
  function initPDPGallery() {
    const thumbs = document.querySelectorAll('.pdp__thumb');
    const mainImg = document.querySelector('.pdp__gallery-main img');
    const main = document.querySelector('.pdp__gallery-main');
    if (!mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.getAttribute('data-src');
        if (src) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
        }
      });
    });

    // Swipe-to-cycle on mobile (where thumbs are hidden) — without this
    // shoppers see only image #1 and never the back / side / detail photos.
    if (main && thumbs.length > 1) {
      const sources = Array.from(thumbs).map(t => t.getAttribute('data-src')).filter(Boolean);
      let index = 0;

      // Inject swipe-position dots so customers know there's more.
      const dots = document.createElement('div');
      dots.className = 'pdp__gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      sources.forEach((_, i) => {
        const d = document.createElement('span');
        d.className = 'pdp__gallery-dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(d);
      });
      main.appendChild(dots);
      const dotEls = dots.querySelectorAll('.pdp__gallery-dot');

      let touchStartX = 0;
      let touchStartY = 0;
      function setIndex(i) {
        index = (i + sources.length) % sources.length;
        mainImg.style.opacity = '0.85';
        setTimeout(() => {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = sources[index];
          thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === index));
          dotEls.forEach((d, idx) => d.classList.toggle('is-active', idx === index));
          mainImg.style.opacity = '1';
        }, 80);
      }
      main.addEventListener('touchstart', e => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        // Horizontal swipe only — ignore vertical scrolls
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          setIndex(index + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
      // Keep index in sync if user clicks a thumb on desktop
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        index = i;
        dotEls.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      }));
    }
  }

  // ── Size Selector ─────────────────────────────────────────
  function initSizeSelector() {
    const btns = document.querySelectorAll('.size-btn');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
      });
    });
  }

  // ── Color Swatches ────────────────────────────────────────
  function initColorSwatches() {
    const swatches = document.querySelectorAll('.color-swatch');
    swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        swatches.forEach(s => s.classList.remove('is-selected'));
        swatch.classList.add('is-selected');
      });
    });
  }

  // ── Email Forms ───────────────────────────────────────────
  function initEmailForms() {
    document.querySelectorAll('.js-email-form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('input[type="email"]');
        const btn = form.querySelector('button[type="submit"]');
        if (!input?.value) return;

        const originalText = btn?.textContent;
        if (btn) btn.textContent = 'Joining...';

        // Shopify customer subscribe endpoint
        try {
          await fetch('/contact#contact_form', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({ 'contact[email]': input.value, form_type: 'customer' })
          });
          input.value = '';
          if (btn) { btn.textContent = '✓ You\'re in!'; }
          setTimeout(() => { if (btn) btn.textContent = originalText; }, 3000);
        } catch {
          if (btn) btn.textContent = originalText;
        }
      });
    });
  }

  // ── Sticky ATC on PDP ─────────────────────────────────────
  function initStickyATC() {
    const atcBtn = document.querySelector('.pdp__atc');
    if (!atcBtn) return;

    const stickyBar = document.querySelector('.pdp-sticky-bar');
    if (!stickyBar) return;

    const obs = new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }

  // ── Add to Cart ───────────────────────────────────────────
  function initAddToCart() {
    async function handleAddToCart(btn, variantId) {
      if (!variantId) return;
      const original = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        /* pchee-cart-safety-20260808: identical to the homepage spotlight bug.
           A sold-out variant answers 422 with a reason; calling that "Error"
           tells the shopper the site is broken. And refreshAndOpen() used to sit
           inside this try, so a drawer that failed AFTER a successful add
           painted an error over an item already in the cart. */
        let added = false;
        if (res.ok) {
          added = true;
          btn.textContent = '✓ Added!';
        } else {
          let reason = '';
          try { const body = await res.json(); reason = (body && (body.description || body.message)) || ''; } catch (e) {}
          btn.textContent = (res.status === 422 || /sold out|unavailable|stock/i.test(reason)) ? 'Sold Out' : 'Could not add';
        }
        if (added) {
          try {
            const cart = await fetch('/cart.js').then(r => r.json());
            // Update cart-count badges only — never the wishlist badge (also class .cart-badge).
            document.querySelectorAll('.cart-badge:not(.wishlist-count)').forEach(badge => {
              badge.textContent = cart.item_count;
              badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
          } catch (e) { /* cosmetic — the item IS in the cart */ }
          try { await window.pcheebumCart?.refreshAndOpen(); } catch (e) { /* same */ }
        }
      } catch(err) {
        btn.textContent = 'Check connection';
      } finally {
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2500);
      }
    }

    // Standalone .js-atc buttons NOT inside a product form (cart drawer upsells,
    // quick-add tiles, recommendation rails). The PDP product-form has its own
    // submit handler inline in product-main.liquid — binding here would duplicate
    // the /cart/add.js call and add 2× per click.
    document.querySelectorAll('.js-atc').forEach(btn => {
      if (btn.closest('form[action*="/cart/add"], form#product-form')) return;
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.getAttribute('data-variant-id');
        await handleAddToCart(btn, variantId);
      });
    });
  }

  // ── Init All ──────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initHeroCarousel();
    initMobileMenu();
    initCartDrawer();
    initScrollReveal();
    initPDPGallery();
    initSizeSelector();
    initColorSwatches();
    initEmailForms();
    initStickyATC();
    initAddToCart();
  });

})();

/* ── Search Overlay + Predictive Search ─────────────────────── */
(function() {
  const overlay      = document.getElementById('search-overlay');
  const backdrop     = overlay?.querySelector('.search-overlay__backdrop');
  const input        = document.getElementById('search-overlay-input');
  const closeBtn     = document.getElementById('search-close-btn');
  const clearBtn     = document.getElementById('search-clear-btn');
  const spinner      = document.getElementById('search-spinner');
  const popularEl    = document.getElementById('search-popular');
  const predictiveEl = document.getElementById('search-predictive-results');
  const listEl       = document.getElementById('search-predictive-list');
  const viewAllEl    = document.getElementById('search-view-all');

  if (!overlay) return;

  /* ── Open / Close ── */
  function openSearch() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input?.focus(), 80);
    // Reset to popular state if input is empty
    if (!input?.value.trim()) showPopular();
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    clearPredictive();
  }

  // Wire all Search buttons
  document.querySelectorAll('[aria-label="Search"]').forEach(btn => {
    if (btn.tagName === 'BUTTON') btn.addEventListener('click', openSearch);
  });
  window.__openSearch = openSearch;

  backdrop?.addEventListener('click', closeSearch);
  closeBtn?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  /* ── Clear button ── */
  input?.addEventListener('input', () => {
    const hasVal = input.value.trim().length > 0;
    if (clearBtn) clearBtn.style.display = hasVal ? 'flex' : 'none';
    if (!hasVal) {
      clearPredictive();
      showPopular();
    }
  });
  clearBtn?.addEventListener('click', () => {
    if (input) { input.value = ''; input.focus(); }
    if (clearBtn) clearBtn.style.display = 'none';
    clearPredictive();
    showPopular();
  });

  /* ── State helpers ── */
  function showPopular() {
    if (popularEl)    popularEl.style.display    = '';
    if (predictiveEl) predictiveEl.style.display = 'none';
  }

  function showPredictive() {
    if (popularEl)    popularEl.style.display    = 'none';
    if (predictiveEl) predictiveEl.style.display = '';
  }

  function clearPredictive() {
    if (listEl)    listEl.innerHTML = '';
    if (viewAllEl) viewAllEl.style.display = 'none';
    showPopular();
  }

  /* ── Format money ── */
  /* Handles Shopify price_min as integer cents (2500 → $25) OR decimal string ("25.00" → $25) */
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    const num = parseFloat(cents);
    if (isNaN(num)) return '';
    const isAlreadyDollars = typeof cents === 'string' && String(cents).indexOf('.') !== -1;
    const dollars = isAlreadyDollars ? num : num / 100;
    return '$' + dollars.toFixed(2).replace(/\.00$/, '');
  }

  /* ── Render one product row ── */
  function renderItem(product) {
    const li = document.createElement('li');
    /* 160×200 portrait crop (was 120×120 square) — clothing photos read better
       in portrait, and the predictive thumb is now 64×80 in CSS. */
    const imgSrc = product.featured_image?.url
      ? product.featured_image.url.replace(/\.[^.]+$/, m => '_160x200' + m)
      : null;

    /* Use Shopify's pre-formatted price string if available; fall back to price_min */
    const price = product.price != null ? product.price : (product.price_min != null ? formatMoney(product.price_min) : '');
    const category = product.product_type || '';

    li.innerHTML = `
      <a href="${product.url}" class="search-predictive__item" role="option">
        ${imgSrc
          ? `<img src="${imgSrc}" alt="${product.title}" class="search-predictive__thumb" loading="lazy" width="64" height="80">`
          : `<div class="search-predictive__thumb-placeholder"></div>`
        }
        <span class="search-predictive__info">
          <span class="search-predictive__name">${product.title}</span>
          ${category ? `<span class="search-predictive__type">${category}</span>` : ''}
        </span>
        ${price ? `<span class="search-predictive__price">${price}</span>` : ''}
      </a>`;
    return li;
  }

  /* ── Search synonyms ──────────────────────────────────────────────
     Shopper vocabulary that appears in no product title. Shopify's
     predictive API returns 0 results for "one piece" while the results
     page OR-matches "one"/"piece" and returns jackets, towels and
     two-piece sets. Expand the alias into the terms that really match.
     Keep in sync with the category routing in sections/main-search.liquid. */
  const SEARCH_SYNONYMS = [
    { match: /one[\s-]?piece|body\s?suit|unitard|catsuit/i, terms: ['jumpsuit', 'romper'] }
  ];

  /* Leggings come in competing lines — Shaping, V-Back Shaping, Sculpting Acid
     Wash, V-Waist — and every title ends "Scrunch Butt Leggings", so a search for
     one line surfaces them all. Drop the qualifiers the shopper didn't type.
     Leggings only, and never down to nothing: same scoping as the results page. */
  function lineFilter(query, products) {
    var q = query.toLowerCase();
    if (q.indexOf('legging') === -1) return products;

    var vback   = /v-?\s?back/.test(q);
    var vwaist  = /v-?\s?waist/.test(q);
    var shaping = q.indexOf('shaping') !== -1;
    var need = [], drop = [];

    if (vwaist)               need = ['v-waist'];
    else if (shaping && vback) { need = ['v-back']; drop = ['acid']; }
    else if (shaping)        { need = ['shaping']; drop = ['v-back', 'v-waist', 'acid']; }
    else return products;

    var kept = products.filter(function (p) {
      var t = (p.title || '').toLowerCase();
      if (need.some(function (n) { return t.indexOf(n) === -1; })) return false;
      return !drop.some(function (d) { return t.indexOf(d) !== -1; });
    });
    return kept.length ? kept : products;
  }

  function synonymTerms(query) {
    const hit = SEARCH_SYNONYMS.find(s => s.match.test(query));
    return hit ? hit.terms : [query];
  }

  /* ── Debounced fetch from Shopify Predictive Search API ── */
  let debounceTimer = null;
  let currentQuery  = '';

  function fetchPredictive(query) {
    currentQuery = query;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      if (!query || query !== currentQuery) return;

      // Show spinner
      if (spinner) spinner.style.display = 'block';

      try {
        /* One request per synonym term (usually just the raw query), merged. */
        const terms = synonymTerms(query);
        const payloads = await Promise.all(terms.map(async (term) => {
          /* pchee-search-drawer-20260730: products only here. Collections and pages are
             fetched in a SEPARATE request below — the predictive API applies
             resources[limit] across ALL requested types combined, so asking for three
             types in one call cut products from 6 to 2. resources[limit_scope] does not
             exist on this endpoint (that is the Storefront API) and adding it made the
             request fail outright. */
          const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url);
          if (!res.ok) throw new Error('Fetch failed');
          return res.json();
        }));

        // Guard stale responses
        if (query !== currentQuery) return;

        const seen = new Set();
        let products = payloads
          .flatMap(d => d?.resources?.results?.products || [])
          .filter(p => {
            if (!p || seen.has(p.url)) return false;
            seen.add(p.url);
            return true;
          })
          .slice(0, 12);

        products = lineFilter(query, products).slice(0, 6);

        if (spinner) spinner.style.display = 'none';

        /* pchee-search-drawer-20260730: fetch collections and pages BEFORE deciding
           what to render. This used to sit after the zero-products early return, so a
           query like 'size chart' or 'shipping' — which matches no product but DOES
           match a page — bailed out with 'No products found' and never showed the one
           result that would have answered the question.

           Separate request on purpose: the predictive API applies resources[limit]
           across all requested types combined, so bundling types starved products
           (6 -> 2). resources[limit_scope] does not exist on this endpoint and adding
           it made the request fail outright. */
        let others = [];
        try {
          const oRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection,page&resources[limit]=4`);
          if (oRes.ok) {
            const od = await oRes.json();
            others = [
              ...((od?.resources?.results?.collections) || []).map(c => ({ ...c, _kind: 'Collection' })),
              ...((od?.resources?.results?.pages) || []).map(p => ({ ...p, _kind: 'Page' })),
            ].filter(o => o && o.url && !seen.has(o.url) && (seen.add(o.url) || true)).slice(0, 4);
          }
        } catch (e) { /* non-fatal */ }
        if (query !== currentQuery) return;

        if (products.length === 0 && others.length === 0) {
          listEl.innerHTML = `<li class="search-predictive__empty">Nothing found for &ldquo;${query}&rdquo;</li>`;
          if (viewAllEl) viewAllEl.style.display = 'none';
          showPredictive();
          return;
        }

        listEl.innerHTML = '';
        products.forEach(p => listEl.appendChild(renderItem(p)));


        if (others.length) {
          const hdr = document.createElement('li');
          hdr.className = 'search-predictive__group';
          hdr.textContent = 'Pages & collections';
          listEl.appendChild(hdr);
          others.forEach(o => {
            const li = document.createElement('li');
            li.className = 'search-predictive__item search-predictive__item--other';
            const a = document.createElement('a');
            a.href = o.url;
            a.className = 'search-predictive__link';
            a.innerHTML = '<span class="search-predictive__other-title"></span><span class="search-predictive__other-kind"></span>';
            a.querySelector('.search-predictive__other-title').textContent = o.title;
            a.querySelector('.search-predictive__other-kind').textContent = o._kind;
            li.appendChild(a);
            listEl.appendChild(li);
          });
        }

        // View all link
        if (viewAllEl) {
          viewAllEl.href = `/search?type=product&q=${encodeURIComponent(query)}`;
          viewAllEl.style.display = '';
        }

        showPredictive();

      } catch (err) {
        if (spinner) spinner.style.display = 'none';
        console.warn('[Pcheebum] Predictive search error:', err);
      }
    }, 220); // 220ms debounce — fast but avoids hammering on every keystroke
  }

  /* ── pchee-recent-searches-20260730 ───────────────────────────────────────
     Returning shoppers re-search the same handful of terms. Storing the last 5
     and showing them above Popular searches turns a repeat visit into one tap.
     localStorage only, clearable, never leaves the browser. Recorded on submit
     (a term someone committed to), not on every keystroke. ─────────────────── */
  var RKEY = 'pchee_recent_searches_v1';
  function recentGet() {
    try { return JSON.parse(localStorage.getItem(RKEY) || '[]').filter(Boolean).slice(0, 5); }
    catch (e) { return []; }
  }
  function recentAdd(term) {
    var t = (term || '').trim();
    if (t.length < 2) return;
    try {
      var list = recentGet().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
      list.unshift(t);
      localStorage.setItem(RKEY, JSON.stringify(list.slice(0, 5)));
    } catch (e) {}
  }
  function recentRender() {
    var host = document.getElementById('search-recent');
    if (!host) return;
    var list = recentGet();
    if (!list.length) { host.hidden = true; return; }
    host.hidden = false;
    host.innerHTML = '';
    var label = document.createElement('p');
    label.className = 'search-overlay__label';
    label.textContent = 'Recent searches';
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'search-recent__clear';
    clear.textContent = 'Clear';
    clear.addEventListener('click', function () {
      try { localStorage.removeItem(RKEY); } catch (e) {}
      recentRender();
    });
    label.appendChild(clear);
    host.appendChild(label);
    var chips = document.createElement('div');
    chips.className = 'search-overlay__chips';
    list.forEach(function (t) {
      var a = document.createElement('a');
      a.className = 'search-overlay__chip';
      a.href = '/search?type=product&q=' + encodeURIComponent(t);
      a.textContent = t;
      chips.appendChild(a);
    });
    host.appendChild(chips);
  }
  recentRender();
  document.querySelector('.search-overlay__form')?.addEventListener('submit', function () {
    recentAdd(input && input.value);
  });
  // Also record when the shopper opens a predictive result rather than submitting.
  listEl?.addEventListener('click', function (e) {
    if (e.target.closest('a')) recentAdd(input && input.value);
  });
  window.__pcheeRecentRender = recentRender;

  /* ── Wire input to predictive fetch ── */
  input?.addEventListener('input', () => {
    const q = input.value.trim();
    if (q.length >= 2) {
      fetchPredictive(q);
    } else if (q.length === 0) {
      if (spinner) spinner.style.display = 'none';
    }
  });

  // Keyboard: Enter still submits the form; arrows could navigate list (future)
  input?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') return; // let the form submit naturally
  });
})();

/* ── pchee-klaviyo-scrolllock-20260730 ────────────────────────────────────────
   P0. Measured on the LIVE theme, desktop, clean profile, no interaction:

     t=3s   body style="position: fixed; top:0; left:0; right:0; width:100%"
            document.scrollHeight  900   (should be 10,950)
            visible Klaviyo popups 0

   The page freezes ~3 seconds after load and there is nothing on screen to
   dismiss. Desktop only; mobile did not reproduce.

   Cause: Klaviyo's onsite forms lock <body> when a popup opens. This theme
   deliberately hides every Klaviyo form via the pchee-suppress-klaviyo-* CSS
   (it ships its own #pcheePopup instead), but CSS cannot stop Klaviyo's JS — so
   the popup opens invisibly, applies its scroll lock, and never gets dismissed
   because the customer cannot see or click it.

   Fix: watch <body> for an externally-applied scroll lock and release it unless
   one of OUR OWN modals is genuinely open. We never fight a legitimate lock —
   the cart drawer, mobile menu, search overlay, size sheet and theme popup all
   keep theirs.

   Do not remove this without first removing the Klaviyo form suppression, or the
   freeze comes straight back.
─────────────────────────────────────────────────────────────────────────────── */
(function () {
  var OURS = [
    '.cart-drawer.is-open',
    '.cdv2-drawer.is-open',
    '.mobile-menu.is-open',
    '.search-overlay.is-open',
    '.pdp-size-sheet.is-open',
    '#pcheePopup:not([hidden])',
    '#size-chart-modal.is-open'
  ].join(',');

  function ourModalOpen() {
    if (document.body.classList.contains('pchee-modal-open')) return true;
    try { return !!document.querySelector(OURS); } catch (e) { return false; }
  }

  function release() {
    var b = document.body;
    if (getComputedStyle(b).position !== 'fixed') return;
    if (ourModalOpen()) return;              // legitimate lock, leave it alone
    // Klaviyo's lock is inline; clearing the inline props restores scrolling
    // without touching any stylesheet rule.
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.height = '';
    b.style.overflow = '';
  }

  if ('MutationObserver' in window) {
    new MutationObserver(release).observe(document.body, {
      attributes: true, attributeFilter: ['style', 'class']
    });
  }
  // The lock can land before the observer attaches, and Klaviyo re-applies it on
  // its own schedule, so sweep for the first 30s as well.
  var n = 0;
  var iv = setInterval(function () { release(); if (++n > 60) clearInterval(iv); }, 500);
  document.addEventListener('DOMContentLoaded', release);
  window.addEventListener('load', release);
})();

/* ── pchee-checkout-fallback-20260730 ─────────────────────────────────────────
   REVENUE SAFETY NET. Do not remove without replacing.

   The cart drawer's only checkout control is injected at runtime by the Get.Plus
   app inside <protectplus-hook>. The theme's own button had been commented out so
   the two would not both render, which made the entire drawer checkout path — the
   primary path on mobile — depend on a third-party script executing.

   PROVEN, not theorised. With third-party hosts blocked (an ad blocker, a vendor
   outage, a JS error, strict privacy mode), a real add-to-cart run produced:
       protectplus buttons present : 0
       visible checkout controls   : []
   A shopper with an item in the bag and no way to pay.

   This reveals the theme's native button only when no app control has appeared.
   When Get.Plus works, the button stays hidden and nothing changes.

   WHY IT LIVES HERE AND NOT IN THE SECTION: the drawer re-renders itself via
   fetch('/?sections=cart-drawer') + innerHTML. Scripts inserted by innerHTML do
   not execute, so an inline copy runs once on first paint and never again — it
   was silently dead in exactly the re-render case that matters. theme.js loads
   once and survives every swap.
─────────────────────────────────────────────────────────────────────────────── */
(function () {
  /* pchee-checkout-gap-20260730: measured on a fast connection, the drawer opens
     ~860-970ms after Add and the app's checkout button arrives 409-644ms later.
     So there is a real window where the shopper sees a full cart and no way to
     pay, and on a slow phone it is longer. 3500ms meant the safety net arrived
     a full second and a half after she had already decided nothing was going to
     happen. 2500ms clears the measured worst case (~1.6s) with headroom, and if
     the app control does turn up late, check() hides the native one again. */
  var REVEAL_AFTER_MS = 2500;

  function appProvidedCheckout() {
    return !!document.querySelector('protectplus-hook .pp-button, protectplus-hook .pp-link');
  }

  function check() {
    var btn = document.getElementById('cdv2-checkout-btn');
    if (!btn) return;
    // Once the dead-click watchdog has revealed it, an app control reappearing
    // must NOT hide it again — that app control is the thing that just failed.
    if (btn.getAttribute('data-revealed-by') === 'deadclick') { btn.hidden = false; return; }
    if (appProvidedCheckout()) { btn.hidden = true; return; }
    btn.hidden = false;
    if (!btn.dataset.bound) {
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () { window.location.href = '/checkout'; });
    }
  }

  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(check, REVEAL_AFTER_MS); }

  schedule();
  window.addEventListener('load', schedule);

  // Re-arm on every drawer re-render. Observing the DOCUMENT (not the drawer node)
  // because the drawer element itself is replaced wholesale on cart mutation.
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* pchee-checkout-deadclick-20260730 — the SECOND failure mode.
     The reveal above only covers Get.Plus never RENDERING a button. It does not
     cover the app rendering fine, the shopper tapping it, and its network call
     failing: she is then left staring at a visible checkout button that does
     nothing, with the native fallback still hidden because a control "exists".

     Measured, not theorised — a journey run produced:
         tap "Checkout+ | $48.80" -> net::ERR_TIMED_OUT, still on /collections/leggings

     So: watch for a tap on an app checkout control, and if the page has not
     started navigating within the grace window, reveal the native button. The
     watchdog is cancelled the moment navigation begins, so a working checkout
     never sees it. */
  var DEADCLICK_GRACE_MS = 7000;
  var deadTimer = null;

  function cancelWatchdog() { clearTimeout(deadTimer); deadTimer = null; }
  window.addEventListener('beforeunload', cancelWatchdog);
  window.addEventListener('pagehide', cancelWatchdog);

  document.addEventListener('click', function (e) {
    var ctl = e.target.closest && e.target.closest('protectplus-hook .pp-button, protectplus-hook .pp-link');
    if (!ctl) return;
    var startedAt = location.href;
    clearTimeout(deadTimer);
    deadTimer = setTimeout(function () {
      if (location.href !== startedAt) return; // it navigated, all good
      var btn = document.getElementById('cdv2-checkout-btn');
      if (!btn) return;
      btn.hidden = false;
      if (!btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', function () { window.location.href = '/checkout'; });
      }
      btn.setAttribute('data-revealed-by', 'deadclick');
      try { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
    }, DEADCLICK_GRACE_MS);
  }, true);
})();
